const status = {
	running: "Active",
	stopped: "Stopped",
	unknown: "Unknown",
};

export default status;
